
import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";

interface CurrencyInputProps {
  value: number;
  onChange: (value: number) => void;
  currency: string;
  onCurrencyChange: (currency: string) => void;
  className?: string;
}

export const CurrencyInput = ({
  value,
  onChange,
  currency,
  onCurrencyChange,
  className,
}: CurrencyInputProps) => {
  const getCurrencySymbol = (currencyCode: string) => {
    switch (currencyCode) {
      case "EUR": return "€";
      case "USD": return "$";
      case "HTG": return "G";
      case "DOP": return "RD$";
      case "GBP": return "£";
      case "CAD": return "CA$";
      case "CHF": return "Fr";
      case "AUD": return "A$";
      case "JPY": return "¥";
      case "CNY": return "¥";
      case "RUB": return "₽";
      case "BRL": return "R$";
      case "MXN": return "Mex$";
      case "INR": return "₹";
      case "MAD": return "DH";
      case "XAF": return "FCFA";
      case "XOF": return "CFA";
      case "NGN": return "₦";
      case "ZAR": return "R";
      case "KES": return "KSh";
      default: return currencyCode;
    }
  };

  return (
    <div className="relative flex gap-2">
      <Input
        type="number"
        value={value || ""}
        onChange={(e) => onChange(parseFloat(e.target.value) || 0)}
        className={className}
        min={0}
        step="0.01"
      />
      <Select value={currency} onValueChange={onCurrencyChange}>
        <SelectTrigger className="w-24">
          <SelectValue placeholder={getCurrencySymbol(currency)} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="EUR">EUR (€)</SelectItem>
          <SelectItem value="USD">USD ($)</SelectItem>
          <SelectItem value="HTG">HTG (G)</SelectItem>
          <SelectItem value="DOP">DOP (RD$)</SelectItem>
          <SelectItem value="GBP">GBP (£)</SelectItem>
          <SelectItem value="CAD">CAD (CA$)</SelectItem>
          <SelectItem value="CHF">CHF (Fr)</SelectItem>
          <SelectItem value="AUD">AUD (A$)</SelectItem>
          <SelectItem value="JPY">JPY (¥)</SelectItem>
          <SelectItem value="CNY">CNY (¥)</SelectItem>
          <SelectItem value="RUB">RUB (₽)</SelectItem>
          <SelectItem value="BRL">BRL (R$)</SelectItem>
          <SelectItem value="MXN">MXN (Mex$)</SelectItem>
          <SelectItem value="INR">INR (₹)</SelectItem>
          <SelectItem value="MAD">MAD (DH)</SelectItem>
          <SelectItem value="XAF">XAF (FCFA)</SelectItem>
          <SelectItem value="XOF">XOF (CFA)</SelectItem>
          <SelectItem value="NGN">NGN (₦)</SelectItem>
          <SelectItem value="ZAR">ZAR (R)</SelectItem>
          <SelectItem value="KES">KES (KSh)</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
